import { useTranslation } from 'react-i18next'
import { useContext, useEffect } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { Breadcrumbs, ListItemButton, Typography } from '@mui/material'

import { UserContext } from '../contexts'
import NextIcon from '../assets/icons/next-icon.svg'
import { CustomerCompanyPaymentsHistory } from '../components/customer-company-details-management/customer-company-payments-history'

const CustomerCompanyPaymentsHistoryManagement = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const { customerCompanyId } = useParams()
  const { userSession } = useContext(UserContext)
  const { t } = useTranslation(['customer-company-details-management'])

  useEffect(() => {
    if (!userSession) {
      return
    }

    if (userSession && (userSession?.role === 'admin-client-builder' || userSession?.role === 'admin' || userSession?.role === 'admin-builder')) {
      navigate('/404')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userSession])

  return (
    <div className="section-container">
      <Breadcrumbs
        separator={
          <img
            src={NextIcon}
            alt="next-icon"
          />
        }
        sx={{ width: '100%' }}
        aria-label="breadcrumb"
      >
        <ListItemButton
          sx={{
            '&.MuiButtonBase-root': {
              padding: '0px'
            },
            '&.MuiButtonBase-root:hover': {
              backgroundColor: 'rgba(0,0,0,0)'
            }
          }}
          onClick={() => {
            if (userSession && (userSession.role === 'super-admin-client' || userSession.role === 'admin-client')) {
              navigate('/')
              return
            }

            navigate('/customer-companies')
          }}
        >
          <Typography
            key="3"
            className="breadcrumb-inactive"
          >
            {userSession && (userSession.role === 'super-admin-client' || userSession.role === 'admin-client') ? t('breadcrumbs.home') : t('breadcrumbs.firstLevel')}
          </Typography>
        </ListItemButton>
        {(!location.state?.previousPath || (location.state?.previousPath && location.state?.previousPath !== '/')) && (
          <ListItemButton
            sx={{
              '&.MuiButtonBase-root': {
                padding: '0px'
              },
              '&.MuiButtonBase-root:hover': {
                backgroundColor: 'rgba(0,0,0,0)'
              }
            }}
            onClick={() => {
              if (
                userSession &&
                (userSession.role === 'super-admin-client' || userSession.role === 'admin-client') &&
                location.state?.previousPath &&
                location.state?.previousPath === `customer-company-payments/${userSession.belongsTo}`
              ) {
                navigate(`/customer-company-payments/${userSession.belongsTo}`)
                return
              }

              if (userSession && (userSession.role === 'super-admin-client' || userSession.role === 'admin-client')) {
                navigate('/insights')
                return
              }

              navigate(`/customer-company-details/${customerCompanyId}`)
            }}
          >
            <Typography
              key="3"
              className="breadcrumb-inactive"
            >
              {userSession &&
              (userSession.role === 'super-admin-client' || userSession.role === 'admin-client') &&
              location.state?.previousPath &&
              location.state?.previousPath === `customer-company-payments/${userSession.belongsTo}`
                ? t('breadcrumbs.individualPayments')
                : userSession && (userSession.role === 'super-admin-client' || userSession.role === 'admin-client')
                ? t('breadcrumbs.insights')
                : t('breadcrumbs.secondLevel')}
            </Typography>
          </ListItemButton>
        )}
        <Typography
          key="3"
          className="breadcrumb-active"
        >
          {t('breadcrumbs.fourthLevel')}
        </Typography>
      </Breadcrumbs>
      <CustomerCompanyPaymentsHistory />
    </div>
  )
}

export default CustomerCompanyPaymentsHistoryManagement
